module.exports = new __parcel__URL__("peacock.80ac60a6.svg").toString();